<template>
  <div v-if="recommendations.length > 0" class="card">
    <div class="p-6 border-b border-gray-200">
      <h3 class="text-xl font-bold flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
          <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
        </svg>
        爱情心理学专家建议
      </h3>
    </div>
    <div class="p-6 space-y-6">
      <div 
        v-for="(rec, index) in recommendations" 
        :key="index"
        class="p-6 bg-gradient-to-br from-white to-gray-50 rounded-lg border-2 border-gray-200"
      >
        <div class="flex items-center gap-3 mb-4">
          <div 
            :class="[
              'w-10 h-10 rounded-lg flex items-center justify-center',
              getColorClass(rec.color, 'bg')
            ]"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round"
              :class="[
                'w-5 h-5',
                getColorClass(rec.color, 'text')
              ]"
              v-html="getIconSvgPath(rec.icon)"
            >
            </svg>
          </div>
          <h4 class="font-semibold text-lg">{{ rec.title }}</h4>
        </div>
        <p class="text-sm text-gray-600 leading-relaxed whitespace-pre-line">{{ rec.advice }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpertRecommendations',
  props: {
    recommendations: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    getIconSvgPath(iconName) {
      const iconPaths = {
        'control': '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle>',
        'jealousy': '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>',
        'dependency': '<path d="M8 2v3"></path><path d="M16 2v3"></path><rect width="16" height="11" x="4" y="7" rx="2"></rect><path d="M10 13v6"></path><path d="M14 13v6"></path>',
        'insecurity': '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>'
      }
      return iconPaths[iconName] || iconPaths['control']
    },
    getColorClass(color, type) {
      const colorMap = {
        'psychology-primary': type === 'bg' ? 'bg-psychology-primary/10' : 'text-psychology-primary',
        'psychology-secondary': type === 'bg' ? 'bg-psychology-secondary/10' : 'text-psychology-secondary',
        'psychology-accent': type === 'bg' ? 'bg-psychology-accent/10' : 'text-psychology-accent',
        'psychology-warning': type === 'bg' ? 'bg-psychology-warning/10' : 'text-psychology-warning'
      }
      return colorMap[color] || (type === 'bg' ? 'bg-gray-100' : 'text-gray-600')
    }
  }
}
</script>

